var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ButtonBorderedKVBase, ButtonKVBase, DefaultModal } from '@/presentation/components';
import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { manageTeachersState } from '../atoms';
import Styles from './delete-teacher-modal-styles.scss';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
const DeleteTeacherModal = ({ teachersManage }) => {
    var _a, _b;
    const [state, setState] = useRecoilState(manageTeachersState);
    const { showCustomSuccess, toastContainer } = useCustomToast({
        containerId: 'manageTeachers',
        toastClassName: Styles.toastClassName
    });
    useEffect(() => {
        if (state.isDeleteModalVisible) {
            document.body.style.overflow = 'hidden'; // Avoid scroll
        }
        else {
            document.body.style.overflow = ''; // Allow scroll
        }
        return () => {
            document.body.style.overflow = ''; // Allow scroll on unmounting
        };
    }, [state.isDeleteModalVisible]);
    const handleCancel = () => {
        setState(Object.assign(Object.assign({}, state), { isDeleteModalVisible: false }));
    };
    const handleConfirm = () => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        setState(Object.assign(Object.assign({}, state), { isLoading: true }));
        yield teachersManage.deleteTeacher({ idUser: (_c = state === null || state === void 0 ? void 0 : state.teacherToDelete) === null || _c === void 0 ? void 0 : _c.id }).then(() => {
            showCustomSuccess('OK', 'Teacher has been deleted permanently');
            setState(Object.assign(Object.assign({}, state), { isDeleteModalVisible: false, reloadTeachers: !state.reloadTeachers, isLoading: false }));
        });
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(DefaultModal, { height: "300", hUnit: "px", width: "432", wUnit: "px", open: state.isDeleteModalVisible, onClose: handleCancel },
            React.createElement("div", { className: Styles.modalMessageWrap },
                React.createElement("div", { className: Styles.title }, "Remove a teacher permanently?"),
                React.createElement("div", { className: Styles.detail }, `${(_a = state === null || state === void 0 ? void 0 : state.teacherToDelete) === null || _a === void 0 ? void 0 : _a.firstName} ${(_b = state === null || state === void 0 ? void 0 : state.teacherToDelete) === null || _b === void 0 ? void 0 : _b.lastName}`),
                React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", onClick: handleConfirm, loading: state.isLoading }, "Confirm"),
                React.createElement(ButtonBorderedKVBase, { type: "button", color: '#999999', onClick: handleCancel }, "Cancel"))),
        toastContainer));
};
export default DeleteTeacherModal;
